module.exports = __webpack_public_path__ + "img/purge.2d1aacd1.svg";